import R from 'ramda';

export default function ReportController($location, $scope, $rootScope, localStorageService, $window, ReportService) {
	var self = this;

	$scope.reportTypes = [{name: 'Exam Reports'}, {name: 'Subject Reports'}];

  ReportService.getAllClassRooms().then(function(resp){
    if(resp.data.length > 0){
      var classRoomList = [];

      for(var i=0; i<resp.data.length; i++){
        var index = R.findIndex(R.propEq('classRoomId', resp.data[i].classRoomId))(classRoomList);
        if(index == -1){
          classRoomList.push({'classRoomId': resp.data[i].classRoomId, 'classRoomName': resp.data[i].classRoomName, 
                      subjectDetails: [{'subjectId': resp.data[i].subjectId, 'subjectName': resp.data[i].subjectName}]});
        }
        else{
          classRoomList[index].subjectDetails.push({'subjectId': resp.data[i].subjectId, 'subjectName': resp.data[i].subjectName});
        }
      }
      self.classRoomList = classRoomList;
      $scope.noReports = false;
    }
    else{
      $scope.noReports = true;
    } 
  });

  $scope.sortTable = function(data){
    $scope.sortType = data.title; 
    $scope.sortReverse = !$scope.sortReverse
    //console.log(data);
  };

  $scope.examSelectDisabled = self.selectedClass ? false : true;

	//self.classRoomList = localStorageService.get('classrooms') || [];

	self.querySearch   = querySearch;
  self.selectedClassChange = selectedClassChange;
  self.searchTextChange   = searchTextChange;

  self.newClassRoom = newClassRoom;
  $scope.showDropDown = false;

  function newClassRoom(state) {
    alert("Sorry! You'll need to create a Class in Dashboard!");
  }

  function querySearch (query) {
    var results = query ? self.classRoomList.filter( createFilterFor(query) ) : self.classRoomList,
      deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } 
    else {
      return results;
    }
  }

  function searchTextChange(text) {
    console.log('Text changed to ' + text);
  }

  function selectedClassChange(item) {
    if(item){
      $scope.selectClassText = false;
      $scope.showTableSpinner = true;
      self.selectedClass = item;
      ReportService.getAllExamsOfClass(self.selectedClass.classRoomId).then(function(resp){
        if(resp.data.length > 0){
          self.examList = resp.data;
          $scope.noExamsFound = false;
          $scope.examSelectDisabled = false;
        }
        else{
          self.selectedExam = "";
          $scope.noExamsFound = true;
        }
      })
    }
    else{
      self.selectedClass = "";
      $scope.showAttTable = false;
      $scope.selectClassText = true;
      $scope.showDots = false;
      self.selectedExam = "";
      $scope.addStudentsMessage = false;
      $scope.examSelectDisabled = true;
    }
    console.log('Item changed to ' + JSON.stringify(item));
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(classObj) {
      return (classObj.classRoomName.toLowerCase().indexOf(lowercaseQuery) === 0);
    };
  };


  // Exam List Auto Select 

  self.querySearch1   = querySearch1;
  self.selectedExamChange = selectedExamChange;
  self.searchTextChange1   = searchTextChange1;

  $scope.showDropDown = false;

  function querySearch1 (query) {
    var results = query ? self.examList.filter( createFilterFor(query) ) : self.examList,
      deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } 
    else {
      return results;
    }
  }

  function searchTextChange1(text) {
    console.log('Text changed to ' + text);
  }

  function selectedExamChange(item) {
    if(item){
      $scope.selectExamText = false;
      $scope.showTableSpinner = true;
      self.selectedExam = item;
    }
    else{
      self.selectedExam = "";
      $scope.selectExamText = true;
      $scope.showDots = false;
      $scope.addStudentsMessage = false;
    }
    console.log('Item changed to ' + JSON.stringify(item));
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(examObj) {
      return (examObj.examName.toLowerCase().indexOf(lowercaseQuery) === 0);
    };
  };


  $scope.clickFilterTable = function(){
  	$scope.showDropDown = !$scope.showDropDown;
  };

  $scope.exportData = function () {
  	setTimeout(function(){
  		var blob = new Blob([document.getElementById('exportable').innerHTML], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
	    });
	    var url = $window.URL || $window.webkitURL;
		  $scope.fileUrl = url.createObjectURL(blob);
  	}, 100)
    
  };

  window.onclick = function(event){
    var clickedElement = angular.element(event.target);
    var clickedDdTrigger = clickedElement.closest('.dd-trigger').length;
    var clickedDdContainer = clickedElement.closest('.dropdown-menu').length;
    if(clickedDdTrigger === 0 && clickedDdContainer === 0){
      $scope.showDropDown = false;
      $scope.$digest();
    }
  };

  $scope.submit = function() {
    if(!self.selectedClass){
      $scope.selectClassError = true;
      return;
    }
    if(!self.selectedExam) {
      $scope.selectClassError = true;
      return;
    }
    var reqObj = {classRoomId: self.selectedClass.classRoomId, subjectDetails: self.selectedClass.subjectDetails,
                  examId: self.selectedExam.examId};
    ReportService.getMarkReports(reqObj).then(function(resp){
      buildTable(resp.data);
      $scope.sortType     = 'Rank'; // set the default sort type
      $scope.sortReverse  = false;
    })
  };


  self.excelName = "Reports.xls"

  $scope.ordered_columns = [];

  var buildTable = function(array){
    console.log(array);
    $scope.all_columns  = [{'title': 'Name', 'checked':true}];

    $scope.tableData = [];
    for(var i=0; i<array.length; i++){
      $scope.all_columns.push({'title': array[i].subjectName, 'checked':true});
      if(i==array.length-1){
        $scope.all_columns.push({'title': 'Total', 'checked':true}, {'title': 'Rank', 'checked':true});
      }
      for(var j=0; j< array[i].marksArray.length; j++){
        var index = R.findIndex(R.propEq('studentId', array[i].marksArray[j].studentId))($scope.tableData);
        if(index == -1){
          index = $scope.tableData.length;
          $scope.tableData.push({'S No' : j+1, 'Name': array[i].marksArray[j].studentName, 'studentId': array[i].marksArray[j].studentId});
          $scope.tableData[index][array[i].subjectName] = array[i].marksArray[j].marksDetails.examMarks || '-';
          $scope.tableData[index]['Total'] = 0;
          if($scope.tableData[index][array[i].subjectName] != '-'){
            $scope.tableData[index]['Total'] = $scope.tableData[index]['Total'] + parseInt($scope.tableData[index][array[i].subjectName]);
          }
        }
        else{
          $scope.tableData[index][array[i].subjectName] = array[i].marksArray[j].marksDetails.examMarks || '-';
          if($scope.tableData[index][array[i].subjectName] != '-'){
            $scope.tableData[index]['Total'] = $scope.tableData[index]['Total'] + parseInt($scope.tableData[index][array[i].subjectName]);
          }
        }
      }
    }
    var diff = function(a, b) { return b.Total - a.Total; };
    var tempTableData = R.sort(diff, $scope.tableData);
    console.log(tempTableData);
    for( var k =0; k< $scope.tableData.length; k++){
      var index = R.findIndex(R.propEq('Total', $scope.tableData[k].Total))(tempTableData);
      if(index != -1){
        $scope.tableData[k]['Rank'] = index + 1;
      }  
    }
    console.log($scope.tableData);

  };


  // $scope.all_columns = [{
  //   "title": "name",
  //   "type": "string",
  //   "checked": true
  // }, {
  //   "title": "age",
  //   "type": "number",
  //   "checked": true
  // }, {
  //   "title": "city",
  //   "type": "string",
  //   "checked": true

  // }, {
  //   "title": "state",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "job",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "biscit",
  //   "type": "number",
  //   "checked": true
  // }, {
  //   "title": "chocolate",
  //   "type": "string",
  //   "checked": true

  // }, {
  //   "title": "manolate",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "sridhar",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "Unittest1",
  //   "type": "string",
  //   "checked": true
  // }, {
  //   "title": "Unittest2",
  //   "type": "number",
  //   "checked": true
  // }, {
  //   "title": "Halfearly",
  //   "type": "string",
  //   "checked": true

  // }, {
  //   "title": "Quaterly",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "UnitTest3",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "Unittest4",
  //   "type": "number",
  //   "checked": true
  // }, {
  //   "title": "Prefinal",
  //   "type": "string",
  //   "checked": true

  // }, {
  //   "title": "Freefinal",
  //   "type": "string",
  //   "checked": false
  // }, {
  //   "title": "Final",
  //   "type": "string",
  //   "checked": false
  // }];
  
  // // i.e. the rows
  // $scope.data = [{
  //   "name": "aleck",
  //   "age": 33,
  //   "city": "Portland",
  //   "state": "OR",
  //   "job": "developer",
  //   "biscit": "nothing",
  //   "chocolate": "something",
  //   "manolate" : "hyperthing",
  //   "sridhar": "everything",
  //   "Unittest1": "90",
  //   "Unittest2": "72",
  //   "Halfearly" : "82",
  //   "Quaterly": "71",
  //   "UnitTest3": "43",
  //   "Unittest4" : "79",
  //   "Prefinal": "63",
  //   "Freefinal": "99",
  //   "Final": "93"
  // }, {
  //   "name": "john",
  //   "age": 40,
  //   "city": "Portland",
  //   "state": "OR",
  //   "job": "designer",
  //   "biscit": "nothing",
  //   "chocolate": "something",
  //   "manolate" : "hyperthing",
  //   "sridhar": "everything",
  //   "Unittest1": "90",
  //   "Unittest2": "72",
  //   "Halfearly" : "82",
  //   "Quaterly": "71",
  //   "UnitTest3": "43",
  //   "Unittest4" : "79",
  //   "Prefinal": "63",
  //   "Freefinal": "99",
  //   "Final": "93"
  // }, {
  //   "name": "erik",
  //   "age": 34,
  //   "city": "Portland",
  //   "state": "OR",
  //   "job": "sales",
  //   "biscit": "nothing",
  //   "chocolate": "something",
  //   "manolate" : "hyperthing",
  //   "sridhar": "everything",
  //   "Unittest1": "90",
  //   "Unittest2": "72",
  //   "Halfearly" : "82",
  //   "Quaterly": "71",
  //   "UnitTest3": "43",
  //   "Unittest4" : "79",
  //   "Prefinal": "63",
  //   "Freefinal": "99",
  //   "Final": "93"
  // }];

  $scope.$watch('all_columns', function() {
    if($scope.all_columns && $scope.tableData){
      update_columns();
      $scope.exportData();
      $scope.showTable = true;
    }
    else{
      $scope.showTable = false;
    }
  }, true);

  var update_columns = function() {
    $scope.ordered_columns = [];
    for (var i = 0; i < $scope.all_columns.length; i++) {
      var column = $scope.all_columns[i];
      if (column.checked) {
        $scope.ordered_columns.push(column);
      }
    }
  };
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-reports/ReportController.js
 **/